import {useAi} from '@/biz/ai/agent'
import {ResponseBody} from './ResponseBody.jsx'

export default ({agentCode, map, ...options}) => {
    const {prjId, sVer} = map.data
    const {pkid: dpId} = map.root.data

    const _ai = useAi({
        agentCode,
        biz: {dpId, prjId, sVer},
        businessKey: dpId,
        compactView: true,
        prjId,
        sVer,
        ...options
    })

    return {
        ..._ai,
        map,
        ResponseBody,

        _getBizMap() {
            const root = map.exportTree(map.root)
            const {data} = map
            const mapJson = JSON.stringify({data, root})
            return {..._ai._getBizMap(), mapJson}
        },
    }
}
